export function zeroPadding(value: number, padding: number): string {
    return `${(Math.pow(10, padding) + value)}`.substring(1);
}

export function defaultLanguage() {
    return navigator.languages.filter(l => !l.match(/\d/))[0];
}

export function formatNumber(value: number | string | null | undefined, format?: Intl.NumberFormatOptions, locale?: string): string | null {
    locale = locale ?? defaultLanguage();
    format = Object.assign({} as Intl.NumberFormatOptions, format);

    if (typeof value === 'string') {
        value = parseInt(value);
    }

    if ((typeof value === 'number')) {
        return (new Intl.NumberFormat(locale, format)).format(value);
    }
    return null;
}

export function formatNumberGroups(value: number, locale?: string): string {
    return formatNumber(value, { useGrouping: true }, locale)!;
}

export function getThousandMarker(locale?: string): string {
    return formatNumberGroups(1000, locale).slice(1, 2);
}